import { Event } from '@domain/event';

export const isEventInThePast = (event?: Event): boolean => {
  return !!event && event.endingTime * 1000 < Date.now();
};
